import API_BASE_URL from "../../../../../Constants";

export const addCustomer = async (formData) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/customers/create`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    throw new Error("Failed to create customer");
  }

  return response.json();
};
